import { graphql } from '../../graphql';
import {
  AreaUnit,
  SaveStripeCustomerInput,
  StartFreeTrialInput,
} from '../../graphql/graphql';
import execute from '../../helpers/functions/api';

export const getCombinedUserData = () => {
  const query = graphql(`
    query GetCombinedUserData {
      getStripeCustomer {
        id
        currency
      }
      getUserData {
        email
        uuid
        country # alpha3 code
        orders {
          plan
          status
        }
      }
    }
  `);

  return execute({ query });
};

export const getOrganizationsUsers = (variables: { unit: AreaUnit }) => {
  const query = graphql(`
    query GetOrganizationsUsers($unit: AreaUnit!) {
      getUserData {
        organizations {
          uuid
          ownerUuid
          users {
            userUuid
            email
            totalArea(unit: $unit)
          }
        }
      }
    }
  `);

  return execute({ query, variables });
};

export const getUserTotalArea = (variables: { unit: AreaUnit }) => {
  const query = graphql(`
    query GetUserTotalArea($unit: AreaUnit!) {
      getUserData {
        totalArea(unit: $unit)
      }
    }
  `);

  return execute({ query, variables });
};

export const saveStripeCustomer = (input: SaveStripeCustomerInput) => {
  const query = graphql(`
    mutation SaveStripeCustomer($input: SaveStripeCustomerInput!) {
      saveStripeCustomer(input: $input) {
        id
      }
    }
  `);

  return execute({ query, variables: { input } });
};

export const startFreeTrial = (input: StartFreeTrialInput) => {
  const query = graphql(`
    mutation StartFreeTrial($input: StartFreeTrialInput!) {
      startFreeTrial(input: $input) {
        isActive
      }
    }
  `);

  return execute({ query, variables: { input } });
};
